// reports/actionTypes.js

const REQUEST_REPORT_DATA = '@@reports/REQUEST_REPORT_DATA';
const REPORT_DATA_RESPONSE = '@@reports/REPORT_DATA_RESPONSE';

const REQUEST_GAMETYPE_DATA = '@@reports/REQUEST_GAMETYPE_DATA';
const GAMETYPE_DATA_RESPONSE = '@@reports/GAMETYPE_DATA_RESPONSE';
const CHANGE_GAMETYPE_VALUE = '@@reports/CHANGE_GAMETYPE_VALUE';
const HYDRATE_TEAM_FILTER = '@@reports/HYDRATE_TEAM_FILTER';

const CHANGE_REPORT_SELECTION = '@@reports/CHANGE_REPORT_SELECTION';
const CHANGE_TEAM_SELECTION = '@@reports/CHANGE_TEAM_SELECTION';
const CHANGE_ALL_SELECTION = '@@reports/CHANGE_ALL_SELECTION';

export default {
    REQUEST_REPORT_DATA,
    REPORT_DATA_RESPONSE,

    REQUEST_GAMETYPE_DATA,
    GAMETYPE_DATA_RESPONSE,
    CHANGE_GAMETYPE_VALUE,
    HYDRATE_TEAM_FILTER,

    CHANGE_REPORT_SELECTION,
    CHANGE_TEAM_SELECTION,
    CHANGE_ALL_SELECTION
}